// @ts-nocheck

import React, { useRef, useState, useEffect } from 'react';
import styled, { css } from 'styled-components';

import { Wifi } from '../../assets/svg';
import { Target } from '../../client';
import { TABBAR_BASE_HEIGHT } from '../../constants/ui/tabbar';
import { usePrevious } from '../../hooks';
import { __ } from '../../i18n/l10n';
import FontSize from '../../renderprops/FontSize';
import ScaleTransitionGroup from '../ScaleTransitionGroup';

const Wrapper = styled.div`
  position: absolute;
  left: 0;
  bottom: ${TABBAR_BASE_HEIGHT}em;
  bottom: calc(constant(safe-area-inset-bottom) + ${TABBAR_BASE_HEIGHT}em);
  bottom: calc(env(safe-area-inset-bottom) + ${TABBAR_BASE_HEIGHT}em);
  width: 100%;
  ${!Target.__MOBILE__
    ? css`
        bottom: 0;
        left: auto;
        right: 0;
        width: auto;
        display: inline-block;
      `
    : undefined}
`;

const Content = styled.div`
  position: relative;
  min-height: 3em;
  background-color: #333;
  color: #ddd;
  padding: 0.5em 0.5em 0.5em 3.5em;
`;

const WifiIcon = styled(Wifi)`
  background-color: #c60000;
  color: #fff;
  position: absolute;
  top: 0;
  left: 0;
  width: 3em;
  height: 100%;
  padding: 0.6em;
  box-sizing: border-box;
`;

const Title = styled.h4`
  margin: 0;
  font-weight: 600;
`;

const StyledContentWrapper = styled.div`
  line-height: normal;
  ${({ $fontSize }) => {
    if (Target.__MOBILE__) {
      return css`
        font-size: ${$fontSize}em;
      `;
    } else {
      return css`
        font-size: 0.8em;
      `;
    }
  }};
`;

const AppNetworkStatus = ({ isDisconnected }) => {
  const timeoutRef = useRef(null);
  const mountedRef = useRef();
  const [show, setShow] = useState(false);
  const previousIsDisconnected = usePrevious(isDisconnected);

  useEffect(() => {
    if (!mountedRef.current) {
      mountedRef.current = true;
      if (isDisconnected) {
        timeoutRef.current = setTimeout(() => setShow(true), 3000);
      }
    } else {
      if (isDisconnected !== previousIsDisconnected) {
        clearTimeout(timeoutRef.current);
        if (isDisconnected) {
          // false -> true
          timeoutRef.current = setTimeout(() => setShow(true), 3000);
        } else {
          // true -> false
          setShow(false);
        }
      }
    }
    return () => {
      clearTimeout(timeoutRef.current);
    };
  }, [isDisconnected, previousIsDisconnected]);

  const sentence = __('Connection error.');
  const text = __('Certain data may not be up to date.');

  return (
    <FontSize>
      {({ fontSize }) => (
        <StyledContentWrapper $fontSize={fontSize}>
          <Wrapper>
            <ScaleTransitionGroup>
              {show ? (
                <Content>
                  <WifiIcon />
                  <Title>{sentence}</Title>
                  <div>{text}</div>
                </Content>
              ) : null}
            </ScaleTransitionGroup>
          </Wrapper>
        </StyledContentWrapper>
      )}
    </FontSize>
  );
};

export default AppNetworkStatus;
